import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export function createPackageReducer(state = initialstate.createPackageRequest, action) {
	switch (action.type) {
		case types.UPDATE_PACKAGE_TYPE_DETAILS:
			return {
				...state,
				packageTypeId: action.payload.packageTypeId,
				packageTypeName: action.payload.packageTypeName,
				packageName: action.payload.packageName,
				recipients: [...action.payload.recipients]
			};
		case types.UPDATE_PACKAGE_CATEGORY_DETAILS:
			return {
				...state,
				categories:
					Object.keys(action.payload).length > 0 ? action.payload : initialstate.createPackageRequest.categories
			};
		case types.GET_PACKAGE_TYPE_DETAILS:
			return {
			...state
			};
		case types.RESET_CREATE_PACKAGE_REQUEST_DETAILS:
			return {
				...state,
				selectedList: initialstate.createPackageRequest.selectedList,
				isCopyEngagementInProgress: action?.payload?.isCopyEngagementInProgress,
			};

		case types.GET_ITEMS_TO_COPY: {
			let {allItemsToCopy, ...newState} = state;
			newState.allItemsToCopy = formatTasksFromResponse(action.response);
			return newState;
		}

		case types.SAVE_SELECTED_ITEMS_TO_COPY: {
			return {
				...state,
				selectedPackageTypeIdToCopy: action.payload.selectedPackageTypeId,
				selectedList: [...action.payload.selectedList]
			};
		}

		case types.REMOVE_SELECTED_ITEMS_TO_COPY: {
			let {selectedList, selectedPackageTypeIdToCopy, ...newState} = state;
			newState.selectedList = [];
			newState.selectedPackageTypeIdToCopy = 0;
			return newState;
		}

		case types.GET_SELECTED_ITEMS_TO_COPY: {
			let {...newState} = state;
			if (newState.selectedPackageTypeIdToCopy != newState.packageTypeId) {
				newState.selectedList = [];
			}
			return newState;
		}
		default:
			return state;
	}
}

export function copyhubSuccessMessageReducer(state = initialstate.copyhubSuccessMessage, action) {
	switch (action.type) {
		case types.SET_CREATE_COPY_SUCCESS_MESSAGE: {
			let newstate = action.successMessage;
			return newstate;
		}
		default:
			return state;
	}
}

export function copyhubErrorMessageReducer(state = initialstate.copyhubErrorMessage, action) {
	switch (action.type) {
		case types.SET_COPY_ERROR_MESSAGE: {
			return action.errorMessage;
		}
		default:
			return state;
	}
}

function formatTasksFromResponse(response) {
	let noDataResponse = {
		data: [],
		page: 0,
		pages: 0,
		totalEntityCount: 0
	};

	if (response && response.data && response.data.length > 0) {
		return response;
	} else if (response && response.length > 0) {
		return response;
	}
	return noDataResponse;
}
